import { render, staticRenderFns } from "./FormPFRP.vue?vue&type=template&id=40a2f76c&scoped=true"
import script from "./FormPFRP.vue?vue&type=script&lang=js"
export * from "./FormPFRP.vue?vue&type=script&lang=js"
import style0 from "./FormPFRP.vue?vue&type=style&index=0&id=40a2f76c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a2f76c",
  null
  
)

export default component.exports